module.exports = __webpack_public_path__ + "img/sidebar-background-5.f1fcfa56.svg";